import { withFuncFactory } from '../../../libs/IdeLink.Web.Common/src/Factory';
import { AuditsPermissions } from '../../modules/Audits/Services/AuditsPermissions';
import { TabPermissionItem } from '../../modules/BackUsers/Pages/components/PermissionsTreeContainer/PermissionsTreeContainer';
import { ChallengesPermissions } from '../../modules/Challenges/Services/ChallengesPermissions';
import { CollectionsPermissions } from '../../modules/Collections/Services/CollectionsPermissions';
import { CommunicationsPermissions } from '../../modules/Communications/Services/CommunicationsPermissions';
import { EventsPermissions } from '../../modules/Events/Services/EventsPermissions';
import { GondolesPermissions } from '../../modules/Gondoles/Services/GondolesPermissions';
import { IndicatorsPermissions } from '../../modules/Indicators/Services/IndicatorsPermissions';
import { NewsPermissions } from '../../modules/News/Services/NewsPermissions';
import { OffersPermissions } from '../../modules/Offers/Services/OffersPermissions';
import { OperationsPermissions } from '../../modules/Operations/Services/OperationsPermissions';
import { QuizzesPermissions } from '../../modules/Quizzes/Services/QuizzesPermissions';
import { SurveysPermissions } from '../../modules/Surveys/Services/SurveysPermissions';
import { VideosPermissions } from '../../modules/Videos/Services/VideosPermissions';
import { getApiPermissionName } from '../../configs/ApiPermissionsMap';
import { ForecastsPermissions } from '../../modules/Offers/Services/ForecastsPermissions';
import { ETribuCoursesPermissions } from '../../../clients/sylviethiriez/Modules/ETribuCourses/Services/ETribuCoursesPermissions';
export const getPermissionModuleNameFromHash = (hash: string): string => {
    //?  if(hash === '#rights-events'){
    //?     return 'Events' where 'Events' is the moduleName of 'events module permission' return by the api
    //?  }

    switch (hash) {
        case OffersPermissions.OFFERS_TAB_HASH:
            return getApiPermissionName(OffersPermissions.OFFERS_KEY);
        case ForecastsPermissions.FORECASTS_TAB_HASH:
            return ForecastsPermissions.FORECASTS_NAME;
        case OperationsPermissions.OPERATIONS_TAB_HASH:
            return getApiPermissionName(OperationsPermissions.OPERATIONS_KEY);
        case CommunicationsPermissions.DIGITAL_MARKETINGS_TAB_HASH:
            return getApiPermissionName(CommunicationsPermissions.DIGITAL_MARKETINGS_KEY);
        case CommunicationsPermissions.PARTNERSHIPS_TAB_HASH:
            return getApiPermissionName(CommunicationsPermissions.PARTNERSHIPS_KEY);
        case CommunicationsPermissions.LEAFLETS_TAB_HASH:
            return getApiPermissionName(CommunicationsPermissions.LEAFLETS_KEY);
        case CollectionsPermissions.COLLECTIONS_TAB_HASH:
            return CollectionsPermissions.COLLECTIONS_CODE;
        case IndicatorsPermissions.INDICATORS_TAB_HASH:
            return IndicatorsPermissions.INDICATORS_CODE;
        case ChallengesPermissions.CHALLENGES_TAB_HASH:
            return ChallengesPermissions.CHALLENGES_CODE;
        case SurveysPermissions.SURVEYS_TAB_HASH:
            return SurveysPermissions.SURVEYS_CODE;
        case QuizzesPermissions.QUIZZES_TAB_HASH:
            return QuizzesPermissions.QUIZZES_CODE;
        case EventsPermissions.EVENTS_TAB_HASH:
            return EventsPermissions.EVENTS_CODE;
        case NewsPermissions.NEWS_TAB_HASH:
            return NewsPermissions.NEWS_CODE;
        case AuditsPermissions.AUDITS_TAB_HASH:
            return AuditsPermissions.AUDITS_CODE;
        case VideosPermissions.VIDEOS_TAB_HASH:
            return VideosPermissions.VIDEOS_CODE;
        case GondolesPermissions.GONDOLES_TAB_HASH:
            return GondolesPermissions.GONDOLES_CODE;
        case ETribuCoursesPermissions.ETRIBU_COURSES_TAB_HASH:
            return ETribuCoursesPermissions.ETRIBU_COURSES_CODE;
        default:
            return getApiPermissionName(OffersPermissions.OFFERS_KEY);
    }
};

const getDefaultPermissionTabs = (): Array<TabPermissionItem> => [];

/** //* Returns the array of TabPermissionItem (for Tabs component) to display */
export const getPermissionTabsFactory = withFuncFactory(getDefaultPermissionTabs);
